module.exports = __webpack_public_path__ + "img/114.6c6b1671.jpg";